module.exports = __webpack_public_path__ + "img/homeimg02.6d554d6e.png";